import type { GQL_ID } from '@@partner:graphql/types'
import type {
  PreviouslyOrderedProductsQuery,
  PreviouslyOrderedProductsQueryVariables
} from '@@partner:graphql/query/product/previouslyOrderedProducts.gql'
import type { Product } from '@@partner:types:app'

import { GQL_QUERY_PREVIOUSLY_ORDERED_PRODUCTS } from '@@partner:graphql/query/product/previouslyOrderedProducts.gql'
import { useQuery } from '@apollo/client'

export function usePreviouslyOrderedProducts (
  customer_id: GQL_ID,
  shop_id: GQL_ID,
  limit: number = 6
) {
  const { data, loading, error, fetchMore } = useQuery<
    PreviouslyOrderedProductsQuery,
    PreviouslyOrderedProductsQueryVariables
  >(GQL_QUERY_PREVIOUSLY_ORDERED_PRODUCTS, {
    variables: {
      customer_id,
      shop_id,
      limit
    }
  })

  const products: Product[] = data?.orderedProducts?.edges ?? []

  return {
    products,
    data,
    loading,
    error,
    fetchMore
  }
}
